import VerificarUsuario from "../../helpers/usuario/verificarUsuario";
import campoExclusivoNumerosCP from "../../helpers/datos/campoExclusivoNumerosCP";

/**
 * Componente de domicilio del contribuyente
 * @param {Object} param0 
 * @returns Componente React
 */
export default function ContactoDomicilio({ catalogos, dataLoaded, data, setData }) {
    VerificarUsuario();
    let direccion;
    const { direcciones } = data;
    direcciones === undefined ? direccion = {} : [direccion] = direcciones;

    const changeMunicipio = e => {
        setData({ ...data, direcciones: [{ ...direccion, idMunicipio: Number(e.target.value), idLocalidad: 0 }] });
    }

    const changeLocalidad = e => {
        setData({ ...data, direcciones: [{ ...direccion, idLocalidad: Number(e.target.value) }] })
    }

    return (
        <div id="domicilio" className="tabcontent">

            <div className="formulario">
                {/* Dirección línea 1 */}
                <div className="boxRow">
                    {/* Tipo de dirección */}
                    <div className="boxColumn flex1">
                        <label className="lblCampo" >Casa Propia</label>
                        <div className="boxRow" >
                            {/* CASA PROPIA: SI */}
                            <div>
                                <span className="radio">
                                    <input className="radioBtn" type="radio" name="casaPropia" value="0"
                                        checked={direccion?.idTipoDireccion === undefined ? true : direccion?.idTipoDireccion === 0}
                                        onChange={e => setData({ ...data, direcciones: [{ ...direccion, idTipoDireccion: Number(e.target.value) }] })}
                                    />Si
                                </span>
                            </div>

                            {/* CASA PROPIA: NO */}
                            <div>
                                <span className="radio">
                                    <input className="radioBtn" type="radio" name="casaPropia" value="1"
                                        checked={direccion?.idTipoDireccion === 1}
                                        onChange={e => setData({ ...data, direcciones: [{ ...direccion, idTipoDireccion: Number(e.target.value) }] })}
                                    />No
                                </span >
                            </div>

                        </div>
                    </div>

                    {/* Domicilio fiscal */}
                    <div className="boxColumn flex1">
                        <label className="lblCampo">Domicilio Fiscal</label>
                        <div className="boxRow" >

                            {/*  DOMICILIO FISCAL: SI */}
                            <div>
                                <span className="radio">
                                    <input className="radioBtn" type="radio" name="domicilioFiscal" value="0"
                                        checked={direccion?.esFiscal === undefined ? true : direccion?.esFiscal === 0}
                                        onChange={e => setData({ ...data, direcciones: [{ ...direccion, esFiscal: Number(e.target.value) }] })}
                                    />Si
                                </span>
                            </div>

                            {/* DOMICILIO FISCAL: NO */}
                            <div>
                                <span className="radio"></span>
                                <input className="radioBtn" type="radio" name="domicilioFiscal" value="1"
                                    checked={direccion?.esFiscal === 1}
                                    onChange={e => setData({ ...data, direcciones: [{ ...direccion, esFiscal: Number(e.target.value) }] })}
                                />No
                                <span />
                            </div>

                        </div>
                    </div>
                </div>

                {/* Dirección línea 2 */}
                <div className="boxRow">
                    {/* Calle */}
                    <div className="boxColumn flex3">
                        <label className="lblCampo" >Calle</label>
                        <div className="search-bar">
                            <input type="text"
                                value={direccion?.calle === undefined ? "" : direccion?.calle}
                                onChange={e => setData({ ...data, direcciones: [{ ...direccion, calle: e.target.value.toUpperCase() }] })}
                            />
                        </div>
                    </div>

                    {/* Número interior */}
                    <div className="boxColumn">
                        <label className="lblCampo" >No. Interior</label>
                        <div className="search-bar">
                            <input type="text"
                                value={direccion?.numeroInterior === undefined ? "" : direccion?.numeroInterior}
                                onChange={e => setData({ ...data, direcciones: [{ ...direccion, numeroInterior: e.target.value.toUpperCase() }] })}
                            />
                        </div>
                    </div>

                    {/* Número exterior */}
                    <div className="boxColumn">
                        <label className="lblCampo" >No. Exterior</label>
                        <div className="search-bar">
                            <input type="text"
                                value={direccion?.numeroExterior === undefined ? "" : direccion?.numeroExterior}
                                onChange={e => setData({ ...data, direcciones: [{ ...direccion, numeroExterior: e.target.value.toUpperCase() }] })}
                            />
                        </div>
                    </div>

                    {/* Código postal */}
                    <div className="boxColumn">
                        <label className="lblCampo" >Código Postal</label>
                        <div className="search-bar">
                            <input type="text" maxLength="5"
                                value={direccion?.codigoPostal === undefined ? "" : direccion?.codigoPostal}
                                onChange={e => campoExclusivoNumerosCP(e.target.value, data, setData)}
                            />
                        </div>
                    </div>
                </div>

                {/* DIRECCIÓN LÍNEA 3 */}
                <div className="boxRow">
                    {/* Colonia */}
                    <div className="boxColumn flex2">
                        <label className="lblCampo" >Colonia</label>
                        <div className="search-bar">
                            <input type="text"
                                value={direccion?.colonia === undefined ? "" : direccion?.colonia}
                                onChange={e => setData({ ...data, direcciones: [{ ...direccion, colonia: e.target.value.toUpperCase() }] })}
                            />
                        </div>
                    </div>

                    {/* Estado */}
                    <div className="boxColumn">
                        <label className="lblCampo" >Estado</label>
                        <div className="search-bar">
                            <select id="selectLugarN"
                                value={direccion?.idEstado??""}
                                onChange={e => setData({ ...data, direcciones: [{ ...direccion, idEstado: Number(e.target.value) }] })}>
                                <option value="">--SELECCIONAR ESTADO--</option>
                                {dataLoaded &&
                                    catalogos?.estados.map(estado =>
                                        <option
                                        checked={estado?.idEstado === direccion?.idEstado}
                                            key={estado.idEstado}
                                            value={estado.idEstado}>
                                            {estado.nombre.toUpperCase()}
                                        </option>
                                    )}
                            </select>
                        </div>
                    </div>

                    {/* Municipio */}
                    <div className="boxColumn">
                        <label className="lblCampo" >Municipio</label>
                        <div className="search-bar">
                            <select id="selectLugarN"
                            value={direccion?.idMunicipio??0}
                                onChange={e => changeMunicipio(e)}>
                                {dataLoaded &&
                                    catalogos.municipios.filter(item => item.idEstado === direccion?.idEstado).length > 0 &&
                                    <option value="">--SELECCIONAR MUNICIPIO--</option>
                                }
                                {dataLoaded &&
                                    catalogos?.municipios.filter(item => item.idEstado === direccion?.idEstado).map(municipio =>
                                        <option
                                            key={municipio.idMunicipio}
                                            value={municipio.idMunicipio}>
                                            {municipio?.nombre.toUpperCase()}
                                        </option>
                                    )}
                            </select>

                        </div>
                    </div>
                </div>

                {/* Dirección línea 4 */}
                <div className="boxRow">
                    {/* Referencia */}
                    <div className="boxColumn flex2">
                        <label className="lblCampo" >Referencia</label>
                        <div className="search-bar">
                            <input type="text"
                                value={direccion?.referencia === undefined ? "" : direccion?.referencia}
                                onChange={e => setData({ ...data, direcciones: [{ ...direccion, referencia: e.target.value.toUpperCase() }] })}
                            />
                        </div>
                    </div>

                    {/* Localidad */}
                    <div className="boxColumn">
                        <label className="lblCampo" >Localidad</label>
                        <div className="search-bar">
                            <select id="selectLugarN"
                                onChange={e => changeLocalidad(e)} 
                                value={direccion?.idLocalidad??0}
                                >
                                {dataLoaded &&
                                    catalogos.localidades.filter(item => item.idMunicipio === direccion?.idMunicipio).length > 0 &&
                                    <option value="">--SELECCIONAR LOCALIDAD--</option>
                                }
                                {dataLoaded &&
                                    catalogos?.localidades.filter(item => item.idMunicipio === direccion?.idMunicipio).map(localidad =>
                                        <option
                                            key={localidad.idLocalidad}
                                            value={localidad.idLocalidad}>
                                            {localidad?.nombre.toUpperCase()}
                                        </option>
                                    )}
                            </select>
                        </div>
                    </div>

                    {/* Cruza con ... */}
                    <div className="boxColumn">
                        <label className="lblCampo" >Cruza con</label>
                        <div className="search-bar">
                            <input type="text"
                                value={direccion?.cruceCalles === undefined ? "" : direccion?.cruceCalles}
                                onChange={e => setData({ ...data, direcciones: [{ ...direccion, cruceCalles: e.target.value.toUpperCase() }] })}
                            />
                        </div>
                    </div>
                </div>
            </div>

        </div>
    );
}